import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { StatCard, StatCardValueVariant } from "../../../components/StartCard";
import { getBillingBilling } from "../../../selectors/billing";
import { formatBalance } from "../../../utils/balance";
import { formatCurrency } from "../../../utils/currency";

import styles from "./BillingBillingStatCards.module.scss";

export const BillingBillingStatCards = () => {
  const { t } = useTranslation();
  const { totalNetFeeSum, totalCollectedFeeSum, expenseSummary, balance } = useSelector(getBillingBilling);

  return (
    <div className={styles.container}>
      <StatCard
        value={formatCurrency(totalNetFeeSum)}
        variant={StatCardValueVariant.Green}
        label={t("billingBillingStatCards.totalFee")}
      />
      <StatCard value={formatCurrency(totalCollectedFeeSum)} label={t("billingBillingStatCards.paidFee")} />
      <StatCard
        value={formatCurrency(expenseSummary)}
        variant={StatCardValueVariant.Orange}
        label={t("billingBillingStatCards.wasteDisposalCosts")}
      />
      <StatCard
        value={formatBalance(totalCollectedFeeSum - expenseSummary)}
        label={t("billingBillingStatCards.balance")}
        secondaryValue={`( ${formatBalance(balance)} )`}
      />
    </div>
  );
};
